// 利用者一覧検索リクエスト項目
export class ManagementListRequest {
    constructor(
        KeyWord = '',
        BirthdayS = '',
        BirthdayE = '',
        Genders = [],
        MngFlags = [],
        Languages = [],
        JoinedDateS = '',
        JoinedDateE = '',
        LeavedDateS = '',
        LeavedDateE = '',
        IncumbentStatuses = [],
        OrganizationPk = '',
        JobCategoryPk = '',
        PositionPk = '',
        EmploymentTypePk = '',
        LocationPk = '',
        OvertimePk = '',
        RegistMethod = '',
        AuthenticateMethod = ''
    ) {
        this.KeyWord = KeyWord;
        this.BirthdayS = BirthdayS;
        this.BirthdayE = BirthdayE;
        this.Genders = Genders;
        this.MngFlags = MngFlags;
        this.Languages = Languages;
        this.JoinedDateS = JoinedDateS;
        this.JoinedDateE = JoinedDateE;
        this.LeavedDateS = LeavedDateS;
        this.LeavedDateE = LeavedDateE;
        this.IncumbentStatuses = IncumbentStatuses;
        this.OrganizationPk = OrganizationPk;
        this.JobCategoryPk = JobCategoryPk;
        this.PositionPk = PositionPk;
        this.EmploymentTypePk = EmploymentTypePk;
        this.LocationPk = LocationPk;
        this.OvertimePk = OvertimePk;
        this.RegistMethod = RegistMethod;
        this.AuthenticateMethod = AuthenticateMethod;
    }
}
// 利用者詳細リクエスト項目
export class UserDetailRequest {
    constructor(
        UserPk = '',
        UserId = '',
        EmployeeNo = '',
        MailAddress = '',
        IniPwdType = '1',
        IniPwdFree = '',
        NameKjLs = '',
        NameKjFs = '',
        NameKnLs = '',
        NameKnFs = '',
        MngFlag = true,
        RegistMethod = '',
        AuthenticateMethod = '',
        LastLoginDt = '',
        SuspendFlag = false,
        UseStartDate = '',
        UseEndDate = '',
        CmpContPks = [],
        Birthday = '',
        Gender = '',
        Language = '',
        JoinedDate = '',
        LeavedDate = '',
        IncumbentStatus = '',
        OrganizationPk = '',
        JobCategoryPk = '',
        PositionPk = '',
        EmploymentTypePk = '',
        LocationPk = '',
        OvertimePk = '',
        UserKeyNo = '',
        TouDataFlag = false
    ) {
        this.UserPk = UserPk;
        this.UserId = UserId;
        this.EmployeeNo = EmployeeNo;
        this.MailAddress = MailAddress;
        this.IniPwdType = IniPwdType;
        this.IniPwdFree = IniPwdFree;
        this.NameKjLs = NameKjLs;
        this.NameKjFs = NameKjFs;
        this.NameKnLs = NameKnLs;
        this.NameKnFs = NameKnFs;
        this.MngFlag = MngFlag;
        this.RegistMethod = RegistMethod;
        this.AuthenticateMethod = AuthenticateMethod;
        this.LastLoginDt = LastLoginDt;
        this.SuspendFlag = SuspendFlag;
        this.UseStartDate = UseStartDate;
        this.UseEndDate = UseEndDate;
        this.CmpContPks = CmpContPks;
        this.Birthday = Birthday;
        this.Gender = Gender;
        this.Language = Language;
        this.JoinedDate = JoinedDate;
        this.LeavedDate = LeavedDate;
        this.IncumbentStatus = IncumbentStatus;
        this.OrganizationPk = OrganizationPk;
        this.JobCategoryPk = JobCategoryPk;
        this.PositionPk = PositionPk;
        this.EmploymentTypePk = EmploymentTypePk;
        this.LocationPk = LocationPk;
        this.OvertimePk = OvertimePk;
        this.UserKeyNo = UserKeyNo;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new UserDetailRequest(
            data.UserPk,
            data.UserId,
            data.EmployeeNo,
            data.MailAddress,
            data.IniPwdType,
            data.IniPwdFree,
            data.NameKjLs,
            data.NameKjFs,
            data.NameKnLs,
            data.NameKnFs,
            data.MngFlag,
            data.RegistMethod,
            data.AuthenticateMethod,
            data.LastLoginDt,
            data.SuspendFlag,
            data.UseStartDate,
            data.UseEndDate,
            data.CmpContPks,
            data.Birthday,
            data.Gender,
            data.Language,
            data.JoinedDate,
            data.LeavedDate,
            data.IncumbentStatus,
            data.OrganizationPk,
            data.JobCategoryPk,
            data.PositionPk,
            data.EmploymentTypePk,
            data.LocationPk,
            data.OvertimePk,
            data.UserKeyNo,
            data.TouDataFlag
        );
    }
}
// 組織詳細リクエスト項目
export class OrganizationInfoRequest {
    constructor(OrganizationPk = '', OrganizationId = '', OrganizationNmJ = '', OrganizationNmE = '', DisplayOrder = '', ParentOrganizationPk = '', OrganizationL1Pk = '', OrganizationL2Pk = '', OrganizationL3Pk = '', OrganizationL4Pk = '', OrganizationL5Pk = '', CmpContPks = [], TouDataFlag = false) {
        this.OrganizationPk = OrganizationPk;
        this.OrganizationId = OrganizationId;
        this.OrganizationNmJ = OrganizationNmJ;
        this.OrganizationNmE = OrganizationNmE;
        this.DisplayOrder = DisplayOrder;
        this.ParentOrganizationPk = ParentOrganizationPk;
        this.OrganizationL1Pk = OrganizationL1Pk;
        this.OrganizationL2Pk = OrganizationL2Pk;
        this.OrganizationL3Pk = OrganizationL3Pk;
        this.OrganizationL4Pk = OrganizationL4Pk;
        this.OrganizationL5Pk = OrganizationL5Pk;
        this.CmpContPks = CmpContPks;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new OrganizationInfoRequest(data.OrganizationPk, data.OrganizationId, data.OrganizationNmJ, data.OrganizationNmE, data.DisplayOrder, data.ParentOrganizationPk, data.OrganizationL1Pk, data.OrganizationL2Pk, data.OrganizationL3Pk, data.OrganizationL4Pk, data.OrganizationL5Pk, data.CmpContPks, data.TouDataFlag);
    }
}
// 職種詳細リクエスト項目
export class JobcategoryInfoRequest {
    constructor(JobCategoryPk = '', JobCategoryId = '', JobCategoryNmJ = '', JobCategoryNmE = '', DisplayOrder = '', CmpContPks = []) {
        this.JobCategoryPk = JobCategoryPk;
        this.JobCategoryId = JobCategoryId;
        this.JobCategoryNmJ = JobCategoryNmJ;
        this.JobCategoryNmE = JobCategoryNmE;
        this.DisplayOrder = DisplayOrder;
        this.CmpContPks = CmpContPks;
    }

    static formApiResponse(data) {
        return new JobcategoryInfoRequest(data.JobCategoryPk, data.JobCategoryId, data.JobCategoryNmJ, data.JobCategoryNmE, data.DisplayOrder, data.CmpContPks);
    }
}
// 職位詳細リクエスト項目
export class PositionInfoRequest {
    constructor(PositionPk = '', PositionId = '', PositionNmJ = '', PositionNmE = '', DisplayOrder = '', CmpContPks = []) {
        this.PositionPk = PositionPk;
        this.PositionId = PositionId;
        this.PositionNmJ = PositionNmJ;
        this.PositionNmE = PositionNmE;
        this.DisplayOrder = DisplayOrder;
        this.CmpContPks = CmpContPks;
    }

    static formApiResponse(data) {
        return new PositionInfoRequest(data.PositionPk, data.PositionId, data.PositionNmJ, data.PositionNmE, data.DisplayOrder, data.CmpContPks);
    }
}
// 雇用形態詳細リクエスト項目
export class EmploymentTypeInfoRequest {
    constructor(EmploymentTypePk = '', EmploymentTypeId = '', EmploymentTypeNmJ = '', EmploymentTypeNmE = '', DisplayOrder = '', CmpContPks = []) {
        this.EmploymentTypePk = EmploymentTypePk;
        this.EmploymentTypeId = EmploymentTypeId;
        this.EmploymentTypeNmJ = EmploymentTypeNmJ;
        this.EmploymentTypeNmE = EmploymentTypeNmE;
        this.DisplayOrder = DisplayOrder;
        this.CmpContPks = CmpContPks;
    }

    static formApiResponse(data) {
        return new EmploymentTypeInfoRequest(data.EmploymentTypePk, data.EmploymentTypeId, data.EmploymentTypeNmJ, data.EmploymentTypeNmE, data.DisplayOrder, data.CmpContPks);
    }
}
// 勤務地詳細リクエスト項目
export class LocationInfoRequest {
    constructor(LocationPk = '', LocationId = '', LocationNmJ = '', LocationNmE = '', DisplayOrder = '', CmpContPks = []) {
        this.LocationPk = LocationPk;
        this.LocationId = LocationId;
        this.LocationNmJ = LocationNmJ;
        this.LocationNmE = LocationNmE;
        this.DisplayOrder = DisplayOrder;
        this.CmpContPks = CmpContPks;
    }

    static formApiResponse(data) {
        return new LocationInfoRequest(data.LocationPk, data.LocationId, data.LocationNmJ, data.LocationNmE, data.DisplayOrder, data.CmpContPks);
    }
}
// 時間外労働時間詳細リクエスト項目
export class OvertimeInfoRequest {
    constructor(OvertimePk = '', OvertimeId = '', OvertimeNmJ = '', OvertimeNmE = '', DisplayOrder = '', CmpContPks = []) {
        this.OvertimePk = OvertimePk;
        this.OvertimeId = OvertimeId;
        this.OvertimeNmJ = OvertimeNmJ;
        this.OvertimeNmE = OvertimeNmE;
        this.DisplayOrder = DisplayOrder;
        this.CmpContPks = CmpContPks;
    }

    static formApiResponse(data) {
        return new OvertimeInfoRequest(data.OvertimePk, data.OvertimeId, data.OvertimeNmJ, data.OvertimeNmE, data.DisplayOrder, data.CmpContPks);
    }
}
// 組織セレクト項目
export class OrganizationIsuResponce {
    constructor(OrganizationPk = '', OrganizationId = '', OrganizationNm = '', OrganizationLv = '', ParentOrgPk = '', PParentOrgPk = '', MonRepFlag = false) {
        this.pk = OrganizationPk;
        this.id = OrganizationId;
        this.name = OrganizationNm;
        this.OrganizationLv = OrganizationLv;
        this.ParentOrgPk = ParentOrgPk;
        this.PParentOrgPk = PParentOrgPk;
        this.MonRepFlag = MonRepFlag;
    }

    static formApiResponse(data) {
        return new OrganizationIsuResponce(data.OrganizationPk, data.OrganizationId, data.OrganizationNm, data.OrganizationLv, data.ParentOrgPk, data.PParentOrgPk, data.MonRepFlag);
    }
}
// 職種セレクト項目
export class JobCategoryIsuResponce {
    constructor(JobCategoryPk = '', JobCategoryId = '', JobCategoryNm = '', TouDataFlag = true) {
        this.pk = JobCategoryPk;
        this.id = JobCategoryId;
        this.name = JobCategoryNm;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new JobCategoryIsuResponce(data.JobCategoryPk, data.JobCategoryId, data.JobCategoryNm, data.TouDataFlag);
    }
}
// 職位セレクト項目
export class PositionIsuResponce {
    constructor(PositionPk = '', PositionId = '', PositionNm = '', TouDataFlag = true) {
        this.pk = PositionPk;
        this.id = PositionId;
        this.name = PositionNm;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new PositionIsuResponce(data.PositionPk, data.PositionId, data.PositionNm, data.TouDataFlag);
    }
}
// 雇用形態セレクト項目
export class EmploymentTypeIsuResponce {
    constructor(EmploymentTypePk = '', EmploymentTypeId = '', EmploymentTypeNm = '', TouDataFlag = true) {
        this.pk = EmploymentTypePk;
        this.id = EmploymentTypeId;
        this.name = EmploymentTypeNm;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new EmploymentTypeIsuResponce(data.EmploymentTypePk, data.EmploymentTypeId, data.EmploymentTypeNm, data.TouDataFlag);
    }
}
// 勤務地セレクト項目
export class LocationIsuResponce {
    constructor(LocationPk = '', LocationId = '', LocationNm = '', TouDataFlag = true) {
        this.pk = LocationPk;
        this.id = LocationId;
        this.name = LocationNm;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new LocationIsuResponce(data.LocationPk, data.LocationId, data.LocationNm, data.TouDataFlag);
    }
}
// 時間外労働時間セレクト項目
export class OvertimeIsuResponce {
    constructor(OvertimePk = '', OvertimeId = '', OvertimeNm = '', TouDataFlag = true) {
        this.pk = OvertimePk;
        this.id = OvertimeId;
        this.name = OvertimeNm;
        this.TouDataFlag = TouDataFlag;
    }

    static formApiResponse(data) {
        return new OvertimeIsuResponce(data.OvertimePk, data.OvertimeId, data.OvertimeNm, data.TouDataFlag);
    }
}
